/** Hope Macy PIS egress IP (must match Cloud NAT static IP in production). */
export const DEFAULT_SLICKPAY_EXPECTED_EGRESS_IP = '35.214.93.168';

export interface SlickpayNetworkSettings {
  expectedEgressIp: string;
  /** IPs registered with Hope Macy for PIS API access. */
  ipWhitelist: string[];
  vpcConnectorName: string;
}

export const DEFAULT_SLICKPAY_NETWORK_SETTINGS: SlickpayNetworkSettings = {
  expectedEgressIp: DEFAULT_SLICKPAY_EXPECTED_EGRESS_IP,
  ipWhitelist: [DEFAULT_SLICKPAY_EXPECTED_EGRESS_IP],
  vpcConnectorName: 'external',
};

/** Merge partial Firestore / diagnostic data with safe defaults. */
export function resolveSlickpayNetworkSettings(
  partial?: Partial<SlickpayNetworkSettings> | null,
): SlickpayNetworkSettings {
  const expectedEgressIp =
    partial?.expectedEgressIp?.trim() || DEFAULT_SLICKPAY_NETWORK_SETTINGS.expectedEgressIp;
  const ipWhitelist =
    Array.isArray(partial?.ipWhitelist) && partial.ipWhitelist.length > 0
      ? partial.ipWhitelist.map((ip) => String(ip).trim()).filter(Boolean)
      : [expectedEgressIp];
  const vpcConnectorName =
    partial?.vpcConnectorName?.trim() || DEFAULT_SLICKPAY_NETWORK_SETTINGS.vpcConnectorName;

  return { expectedEgressIp, ipWhitelist, vpcConnectorName };
}
